import { React, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { setDismissed } from 'features/MiniBookingWidget/MiniBookingWidgetSlice';
import { openDrawer } from 'features/drawersSlice';
import { getWidgetPosition, makeStatsRequestThrottled } from '../../lib';
import { WIDGET_STATS_SETTINGS } from '../../config';

import './SmallTextMultipropertyWidget.css';

const SmallTextMultipropertyWidget = ({ position, mobile }) => {
    position = position || 'top-left';

    const hidden = useSelector((state) => state.miniBookingWidget.hidden);
    const dispatch = useDispatch();
    const data = useSelector((state) => state.miniBookingWidget?.data) || {};
    const widgetPosition =
        useSelector((state) => state.miniBookingWidget?.widgetPosition) || {};
    const smallMultipropBtnText = useSelector(
        (state) => state.miniBookingWidget?.smallMultipropBtnText
    );
    const { Behavior: clickAction, propertyID: propertyId } = data;
    const isDismissed = useSelector(
        (state) => state.miniBookingWidget.isDismissed
    );
    const smallMultipropBtnTextColor = useSelector(
        (state) =>
            state.multiproperty?.multipropertyOptions
                ?.smallMultipropertyTextBtnColor
    );

    const widgetPositionStyles = getWidgetPosition(widgetPosition);

    const dismissWidget = () => {
        dispatch(setDismissed({ isDismissed: true }));
        // saveWidgetStateToLS({ isDismissed: true });
    };
    const onClick = useCallback(() => {
        if (mobile) {
            dispatch(openDrawer({ drawerId: 'MobileMultipropertyDrawer' }));
        } else {
            dispatch(openDrawer({ drawerId: 'BigBookingWidgetDrawer' }));
        }
        makeStatsRequestThrottled(
            WIDGET_STATS_SETTINGS.actions.click,
            propertyId
        );
    }, [clickAction]);

    const removeShownClass = () => {
        const element = document.querySelector(
            '#ab-small-text-multiproperty-btn'
        );
        element.classList.remove('shown');
    };

    const inlineStyles = { display: hidden ? 'none' : 'block' };
    if (data.pluginZIndex) {
        inlineStyles.zIndex = data.pluginZIndex;
    }
    if (smallMultipropBtnTextColor) {
        inlineStyles.backgroundColor = '#' + smallMultipropBtnTextColor;
    }

    if (isDismissed) {
        return null;
    }
    return (
        <div
            className={`ab-bubble_text ${position} shown`}
            id="ab-small-text-multiproperty-btn"
            onClick={onClick}
            style={{
                ...widgetPositionStyles,
                ...inlineStyles,
            }}
        >
            <p>{smallMultipropBtnText}</p>
            <button
                type="button"
                className="js-close-button ab-close-button icon"
                onClick={(event) => {
                    event.stopPropagation();
                    dismissWidget();
                    removeShownClass();
                }}
            ></button>
            <span
                className="ab-arrow js-arrow"
                style={{
                    ...inlineStyles,
                }}
            ></span>
        </div>
    );
};

SmallTextMultipropertyWidget.propTypes = {
    position: PropTypes.string,
    mobile: PropTypes.bool,
};

export default SmallTextMultipropertyWidget;
